module.exports = __webpack_public_path__ + "img/React.580ffd26.png";